import * as React from "react"
import moment from 'moment';
import "./ReleaseTemplate.scss";
import { HeadTag } from "~/pages/_headTag";
import { PageTemplate } from "~/pages/_pageTemplate";
import DownloadBanner from "~/components/modules/donwloadBanner";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { ReleaseContext } from "gatsby-node";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function Template({ pageContext }: { pageContext: {data: ReleaseContext}}) {

    if(!pageContext.data) return "";

    let content = documentToReactComponents(JSON.parse(pageContext.data.body.raw), {
        renderText: text => text.split("\n").flatMap((text, i) => [i > 0 && <br />, text])
    });
    const title = pageContext.data.title;
    const dateString = pageContext.data.date;
    const date = moment(dateString).format("YYYY/M/D");
    
    

    
    
    return (
        <PageTemplate>

                <section className="common_section common_section--bg_heavy">
                    <h2 className="common_h2">お知らせ</h2>
                    <div className="common_section__content common_float_lg">
                        <div className="release_logo">
                            <img src="/images/logo/logo_mark.svg" alt="sally127ロゴ" />
                        </div>
                        <div className="release_content">
                            <p className="release_date">{date}</p>
                            <h1 className="release_heading">{title}</h1>
                            <div className="release_body">{content}</div>
                            <GatsbyImage className="release_subimage"
                                image={getImage(pageContext.data.sub_image?.gatsbyImageData)!}
                                alt = ""
                                width={pageContext.data.sub_image?.width}
                                height={pageContext.data.sub_image?.height}
                            />
                        </div>
                    </div>
                </section>


            <DownloadBanner />
        </PageTemplate>
    )
}

export const Head = ({ pageContext }: { pageContext: {data: ReleaseContext}}) => {

    if(!pageContext.data) return "";
    const title = pageContext.data.title;
    return <HeadTag pageTitle={title}/>

}